import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { DynamicListDataComponent } from 'src/app/components/pages-partials/card-list/dynamic-list-data/dynamic-list-data.component';
import { HttpTranslateFactory } from 'src/app/helpers';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CustomPipesModule } from 'src/app/pipes/custom-pipes.module';
import { ActionFormModule } from "../action-form/action-form.module";
import { CardHeaderComponent } from './card-header/card-header.component';
import { CardLinkComponent } from './card-link/card-link.component';
import { CardListComponent } from './card-list/card-list/card-list.component';
import { VehicleInfoComponent } from './vehicle-info/vehicle-info/vehicle-info.component';
import { ConditionalBlockComponent } from './conditional-block/conditional-block.component';
import { DetailItemContainerComponent } from './detail-item/detail-item-container/detail-item-container.component';
import { CardListLazyloadComponent } from './card-list/card-list/card-list-lazyload.component';
import { MatDialogModule } from '@angular/material/dialog';
import { AddAnprRecordDialogComponent } from './vehicle-info/add-anpr-record-dialog/add-anpr-record-dialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';
import { DynamicDataListModule } from 'src/app/components/dynamic-data-list/dynamic-data-list.module';
import { ConfirmDialogComponent } from './Dialogs/confirm-dialog/confirm-dialog.component';

@NgModule({
  declarations: [
    CardHeaderComponent,
    ConditionalBlockComponent,
    DetailItemContainerComponent,
    CardListComponent,
    CardListLazyloadComponent,
    CardLinkComponent,
    VehicleInfoComponent,
    DynamicListDataComponent,
    AddAnprRecordDialogComponent,
    ConfirmDialogComponent
  ],
  imports: [
    CommonModule,
    ActionFormModule,
    NgbPaginationModule,
    CustomPipesModule,
    DynamicDataListModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    TranslateModule.forChild({
      loader: {
        deps: [HttpClient],
        provide: TranslateLoader,
        useFactory: HttpTranslateFactory,
      },
    }),
  ],
  exports: [
    CardHeaderComponent,
    ConditionalBlockComponent,
    DetailItemContainerComponent,
    CardListComponent,
    CardListLazyloadComponent,
    CardLinkComponent,
    VehicleInfoComponent,
    DynamicListDataComponent,
    ConfirmDialogComponent
  ],
})
export class PagesPartialsModule {}
